import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ApiCalling from "../ApiServices/ApiCalling";
import AuthInfoObj from "../ApiServices/AuthInfoObj";
import { APPID, VERSION, REFERER } from "../Config";

const PgRedirectB2C = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [pgStatusData, setPgStatusData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [seconds, setSeconds] = useState(5);

  // ✅ Safely parse session data
  let redirectedFrom = "/home";
  try {
    const stored = sessionStorage.getItem("pgRedirectedFrom");
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed?.path) redirectedFrom = parsed.path;
    }
  } catch (err) {
    console.warn("Invalid sessionStorage format for pgRedirectedFrom");
  }

  const getPaymentGatewayStatus = async (id) => {
    try {
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/CheckPGStatus",
        data: { OrderID: id },
        headers: {
          "Content-Type": "application/json",
          AppID: APPID,
          Version: VERSION,
          Session: AuthInfoObj().session,
          SessionID: AuthInfoObj().sessionID,
          UserID: AuthInfoObj().userID,
          Referer: REFERER,
        },
      });

      if (res?.statuscode === 1) {
        setPgStatusData(res);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error in getPaymentGatewayStatus:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tid = queryParams.get("TID");

    if (tid) {
      getPaymentGatewayStatus(tid);
    } else {
      setLoading(false);
    }
  }, [location.search]);

  useEffect(() => {
    if (!loading) {
      const timer =
        seconds > 0 &&
        setInterval(() => {
          setSeconds((prev) => prev - 1);
        }, 1000);

      if (seconds === 0) {
        navigate(redirectedFrom);
      }

      return () => clearInterval(timer);
    }
  }, [seconds, loading, navigate, redirectedFrom]);

  const statusIcons = {
    1: "assets/pwa-static/pwa/images/icons/pending.png",
    2: "assets/pwa-static/pwa/images/icons/tick.png",
    3: "assets/pwa-static/pwa/images/icons/failed.png",
  };

  const statusText = {
    1: "Payment is Pending",
    2: "Transaction Successful",
    3: "Transaction Failed",
  };

  if (loading) {
    return (
      <div className="content">
        <div className="cus-recharge-container center">
          <img
            src="/assets/pwa-static/pwa/images/icons/pending.png"
            alt="Pending"
            className="spin"
            style={{ width: 60 }}
          />
          <div className="loader-text">Waiting for confirmation...</div>
        </div>
        <style>{`
          .center { display: flex; flex-direction: column; align-items: center; margin-top: 80px; }
          .spin { animation: spin 1.5s linear infinite; }
          @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
          .loader-text { margin-top: 12px; font-weight: 500; font-size: 16px; color: #333; }
        `}</style>
      </div>
    );
  }

  if (!pgStatusData) {
    return (
      <div className="content">
        <div className="cus-recharge-container center">
          <div style={{ fontSize: 18, color: "#e74c3c", fontWeight: "bold" }}>
            Invalid or Missing Transaction ID
          </div>
          <div style={{ marginTop: 10, color: "#555" }}>
            Please check the link or try again later.
          </div>
          <div
            onClick={() => {
              navigate(redirectedFrom);
            }}
          >
            <span className="redirect-timer manual-redirect">Click here</span>{" "}
            if you are not automatically redirected...
          </div>
        </div>
        <style>{`
          .center {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 80px;
            text-align: center;
          }
          .redirect-timer {
            margin-top: 20px;
            font-size: 14px;
            color: #444;
            font-weight: 500;
          }
          .manual-redirect {
            margin-top: 8px;
            font-size: 13px;
            color: #007bff;
            cursor: pointer;
            text-decoration: underline;
          }
          .manual-redirect:hover {
            color: #0056b3;
          }
        `}</style>
      </div>
    );
  }

  const status = pgStatusData.status;
  const message = statusText[status] || "Unknown status";

  return (
    <div className="content">
      <div className="cus-recharge-container center">
        <div className="success-check">
          <img
            src={statusIcons[status] || statusIcons[1]}
            alt="Status Icon"
            style={{ width: 60 }}
          />
        </div>
        <div className="cus-recharge-title">{message}</div>
        {/* <div className="cus-recharge-msg">
          Transaction ID: <strong>{pgStatusData?.checkID || "-"}</strong>
        </div> */}
        <div className="redirect-timer">
          Redirecting to previous page in <span>{seconds}</span> seconds...
        </div>
        <div
          onClick={() => {
            navigate(redirectedFrom);
          }}
        >
          <span className="redirect-timer manual-redirect">Click here</span> if
          you are not automatically redirected...
        </div>
      </div>
      <style>{`
        .center {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 80px;
        }
        .cus-recharge-title {
          font-size: 20px;
          font-weight: bold;
          margin-top: 10px;
          color: #444;
        }
        .cus-recharge-msg {
          font-size: 14px;
          margin-top: 6px;
          color: #777;
        }
        .redirect-timer {
          margin-top: 20px;
          font-size: 14px;
          color: #444;
          font-weight: 500;
        }
        .success-check {
          position: relative;
        }
        .manual-redirect {
          margin-top: 8px;
          font-size: 13px;
          color: #007bff;
          cursor: pointer;
          text-decoration: underline;
        }
        .manual-redirect:hover {
          color: #0056b3;
        }
      `}</style>
    </div>
  );
};

export default PgRedirectB2C;
